import logo from "assets/logoSuitPods.png";

export const images = {
  logo,
};
